namespace TabAurous.Finance {
    export namespace PDCClearanceService {
        export const baseUrl = 'Finance/PDCClearance';

        export declare function Create(request: Serenity.SaveRequest<PDCClearanceRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PDCClearanceRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PDCClearanceRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PDCClearanceRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function PDCVouchersList(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PDCClearanceRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Finance/PDCClearance/Create",
            Update = "Finance/PDCClearance/Update",
            Delete = "Finance/PDCClearance/Delete",
            Retrieve = "Finance/PDCClearance/Retrieve",
            List = "Finance/PDCClearance/List",
            PDCVouchersList = "Finance/PDCClearance/PDCVouchersList"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'PDCVouchersList'
        ].forEach(x => {
            (<any>PDCClearanceService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
